import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toastSubject = new Subject<any>();
  //toastState$ = this.toastSubject.asObservable();

  showSuccess(message: string) {
    this.showToast(
      message,
      'Success',
      'toast-success text-success font-medium p-0',
      'bi bi-check-circle-fill'
    );
  }

  showError(message: string) {
    this.showToast(
      message,
      'Error',
      'toast-error  text-danger font-medium p-0',
      'bi bi-exclamation-circle-fill'
    );
  }

  showInfo(message: string) {
    this.showToast(
      message,
      'Information',
      'toast-info text-info font-medium p-0',
      'bi bi-info-circle-fill'
    );
  }

  private showToast(
    message: string,
    header: string,
    classname: string,
    icon: string
  ) {
    this.toastSubject.next({
      //header: header,
      text: message, // Ensure text is assigned to 'message'
      classname: classname,
      autohide: true,
      delay: 3000,
      icon: icon,
    });
  }
}
